export const categories = [
  {
    id: "caibiao",
    name: "才艺表演",
    slug: "caibiao",
    description: "汇聚各类音乐、舞蹈、乐器演奏等才艺直播，发现更多精彩表演内容",
    image: "https://readdy.ai/api/search-image?query=Young%20female%20singer%20performing%20with%20acoustic%20guitar%20in%20a%20warm%20cozy%20studio%20with%20soft%20ambient%20lighting%20and%20string%20lights%20background%2C%20artistic%20photography%20style%20with%20shallow%20depth%20of%20field%2C%20warm%20coral%20and%20gold%20accents%2C%20professional%20live%20streaming%20setup%20visible&width=800&height=600&seq=cat-talent-01&orientation=landscape",
    icon: "ri-music-line",
    count: 1248,
  },
  {
    id: "youxi",
    name: "游戏直播",
    slug: "youxi",
    description: "热门游戏实时直播，与主播一起畅玩游戏世界，感受竞技魅力",
    image: "https://readdy.ai/api/search-image?query=Gaming%20streamer%20setup%20with%20RGB%20lighting%20and%20multiple%20monitors%20displaying%20popular%20games%2C%20professional%20gaming%20chair%20and%20headset%2C%20modern%20gaming%20room%20with%20neon%20accents%2C%20clean%20and%20sharp%20photography%20style%2C%20dark%20background%20with%20colorful%20highlights&width=800&height=600&seq=cat-game-02&orientation=landscape",
    icon: "ri-gamepad-line",
    count: 2156,
  },
  {
    id: "liaotian",
    name: "聊天互动",
    slug: "liaotian",
    description: "轻松愉快的聊天直播间，与主播零距离互动交流，分享生活点滴",
    image: "https://readdy.ai/api/search-image?query=Cozy%20conversation%20live%20streaming%20scene%20with%20warm%20lighting%2C%20comfortable%20living%20room%20style%20setting%20with%20soft%20textiles%20and%20plants%2C%20friendly%20atmosphere%20with%20golden%20hour%20light%20streaming%20through%20window%2C%20natural%20and%20relaxed%20photography%2C%20warm%20coral%20and%20cream%20tones&width=800&height=600&seq=cat-chat-03&orientation=landscape",
    icon: "ri-chat-3-line",
    count: 1892,
  },
  {
    id: "huwai",
    name: "户外直播",
    slug: "huwai",
    description: "跟随主播探索户外精彩世界，旅行、美食、探险等实景直播",
    image: "https://readdy.ai/api/search-image?query=Travel%20vlogger%20live%20streaming%20outdoors%20in%20a%20beautiful%20natural%20landscape%20with%20mountains%20and%20golden%20sunset%20light%2C%20holding%20smartphone%20gimbal%2C%20adventure%20travel%20photography%20style%20with%20warm%20earthy%20tones%2C%20scenic%20natural%20background&width=800&height=600&seq=cat-outdoor-04&orientation=landscape",
    icon: "ri-compass-3-line",
    count: 967,
  },
  {
    id: "meishi",
    name: "美食直播",
    slug: "meishi",
    description: "烹饪教学、美食探店、吃播分享，满足你的味蕾与好奇心",
    image: "https://readdy.ai/api/search-image?query=Food%20live%20streaming%20scene%20with%20beautifully%20plated%20dishes%20on%20wooden%20table%2C%20warm%20kitchen%20lighting%20with%20steam%20rising%20from%20freshly%20cooked%20meal%2C%20professional%20food%20photography%20style%20with%20rich%20warm%20tones%2C%20copper%20cookware%20and%20fresh%20ingredients%20visible&width=800&height=600&seq=cat-food-05&orientation=landscape",
    icon: "ri-restaurant-line",
    count: 756,
  },
  {
    id: "tiyu",
    name: "体育赛事",
    slug: "tiyu",
    description: "精彩体育赛事直播解说，篮球、足球、电竞等热门赛事一网打尽",
    image: "https://readdy.ai/api/search-image?query=Sports%20commentary%20live%20streaming%20studio%20with%20large%20screen%20showing%20basketball%20game%2C%20professional%20broadcast%20setup%20with%20multiple%20monitors%2C%20dynamic%20sports%20photography%20style%2C%20warm%20studio%20lighting%20with%20coral%20and%20dark%20accents%2C%20professional%20atmosphere&width=800&height=600&seq=cat-sports-06&orientation=landscape",
    icon: "ri-basketball-line",
    count: 1089,
  },
  {
    id: "jiaoyu",
    name: "知识教育",
    slug: "jiaoyu",
    description: "在线学习新技能，语言、编程、设计等各领域专家直播教学",
    image: "https://readdy.ai/api/search-image?query=Online%20education%20live%20streaming%20setup%20with%20digital%20whiteboard%20and%20professional%20teacher%20in%20modern%20studio%2C%20warm%20lighting%20with%20bookshelves%20background%2C%20clean%20minimalist%20photography%20style%2C%20professional%20yet%20approachable%20atmosphere%2C%20warm%20cream%20and%20wood%20tones&width=800&height=600&seq=cat-edu-07&orientation=landscape",
    icon: "ri-book-open-line",
    count: 534,
  },
  {
    id: "shenghuo",
    name: "生活分享",
    slug: "shenghuo",
    description: "日常生活vlog直播，家居、宠物、穿搭等生活美学内容分享",
    image: "https://readdy.ai/api/search-image?query=Cozy%20home%20lifestyle%20live%20streaming%20scene%20with%20indoor%20plants%20and%20warm%20decor%2C%20natural%20light%20from%20large%20windows%2C%20Scandinavian%20style%20interior%20with%20textiles%20and%20books%2C%20soft%20photography%20style%20with%20cream%20and%20coral%20accents%2C%20peaceful%20atmosphere&width=800&height=600&seq=cat-life-08&orientation=landscape",
    icon: "ri-home-heart-line",
    count: 643,
  },
];

export const getCategoryBySlug = (slug: string) => {
  return categories.find((c) => c.slug === slug);
};

export const getCategoryById = (id: string) => {
  return categories.find((c) => c.id === id);
};